import logo from './logo.svg';
import './App.css';
import Header from './Header';
import Main from './Main';
import './Main.css';
import './index.css';
import { AuthProvider } from './context';
import { ScrollToTop } from './utilFunctions';

function App() {
	return (
		<AuthProvider>
		<div className="App">
			<Main />
		</div>
		</AuthProvider>
	);
}

export default App;
